import { types } from '../types/types';
import { ORDER_INIT } from '../constants/constants';

const initialState = {
    order_count: { // cantidad de pedidos
        approved: 0,
        inactive: 0
    },
    orders: [], // pedidos aprobados/pagados
    inactive_orders: [], // otros pedidos de cliente
    buyAgainProducts: [], // productos comprados
    activeOrder: ORDER_INIT
};

export const userAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.userOrderList:
            return {
                ...state,
                ...action.payload
            };
        case types.userOrderSelected:
            return {
                ...state,
                activeOrder: action.payload
            };
        case types.userOrderUpdated: {
            const { order_num, ...data } = action.payload;

            let approved_orders = [...state.orders];
            const i = approved_orders.findIndex(e => Number(e.order_num) < Number(order_num));
            if (i === -1) // al inicio de la lista
                approved_orders.push({ order_num, ...data });
            else // se inserta donde corresponde
                approved_orders.splice(i, 0, { order_num, ...data });
            return {
                ...state,
                inactive_orders: state.inactive_orders.filter(e => e.order_num !== order_num),
                orders: approved_orders
            };
        }
        case types.userMoreOrders: {
            const { _class, orders } = action.payload;
            return {
                ...state,
                [_class]: [...state[_class], ...orders]
            };
        }
        case types.userOrderRemoved:
            return {
                ...state,
                inactive_orders: [
                    ...state.abandoned_orders.filter(e => e.order_num !== action.payload)
                ]
            };
        case types.userOrderRestored:
            const orderList = [action.payload, ...state.inactive_orders].sort((a, b) => b.order_num - a.order_num);
            return {
                ...state,
                inactive_orders: [...orderList]
            };
        default:
            return state;
    };
};